import { Component, OnInit, ViewChild, OnDestroy, ElementRef } from '@angular/core';
import { FormGroup, FormArray, FormBuilder, Validators } from "@angular/forms";
import { ConfirmationService, MessageService } from 'primeng/api';
import { Router, ActivatedRoute } from '@angular/router';
import { RewardsService } from '../../../services/rewards.service';
import { FileUpload } from 'primeng/fileupload';
import { environment } from "./../../../../environments/environment";
import { TokenStorageService } from 'src/app/services/token-storage.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ImageCroppedEvent, ImageTransform } from 'ngx-image-cropper';
@Component({
  selector: 'app-rewards-add',
  templateUrl: './edit.component.html',
  styleUrls: ['./edit.component.scss'],
  providers: [ConfirmationService, MessageService, RewardsService]
})

export class RewardEditComponent implements OnInit, OnDestroy {

  private destroy$ = new Subject<void>();
  rid;
  rewardData: any;
  deleted_images: any[] = [];
  update_rewardImageLink_info: any[] = [];
  showRewardImageError: boolean = false;
  errorMessage = '';
  staticPath: string;
  submitted = false;
  id: string;
  isAddMode: boolean;
  pagetitle: string;
  rewardForm: FormGroup;
  public loggedInUser;
  public userId;
  public userRoleId;
  public rewardModule;
  public loggedInUserPermissions;
  public rewardPermissions: any[] = [];
  public mobileUploadedFiles: any[] = [];
  sampleRewordImagesLinkArray: any[] = [];
  @ViewChild('fileUpload') fileUpload!: FileUpload;
  @ViewChild('fileUpload', { read: ElementRef }) fileUploadEl!: ElementRef;
  cropDialog: boolean = false;
  imageChangedEvent: any = '';
  croppedImage: any = '';
  imageQueue: any[] = [];
  currentImageIndex: number = 0;
  croppedImageMaxSize = 1000000;
  imageSize = 1000000;
  croppedImageSize = 0;
  croppedImageError: string | null = null;
  scale = 1;
  transform: ImageTransform = {};
  batchCropCompleted = false;
  isApplyingCrop = false;
  private batchStartImageCount = 0;
  @ViewChild('fileInput') fileInput: FileUpload;
  
  constructor(private rewardsService: RewardsService, private router: Router, private activatedRoute: ActivatedRoute, private formBuilder: FormBuilder, private messageService: MessageService, private confirmationService: ConfirmationService, private tokenStorageService: TokenStorageService) { }

  ngOnInit() {
    this.loggedInUser = this.tokenStorageService.getUser();
    this.userId = this.loggedInUser.userdata.id;
    this.userRoleId = this.loggedInUser.userdata.role;
    this.rewardModule = "Rewards Management";
    this.loggedInUserPermissions = this.tokenStorageService.getUserPermissions();
    this.loggedInUserPermissions.forEach(permission => {
      if (permission.module == this.rewardModule) {
        let permissionObj = {
          moduleName: permission.module,
          status: permission.status,
          permission: permission.permission
        }
        this.rewardPermissions.push(permissionObj);
      }
    });
    if (this.rewardPermissions.length == 0) {
      this.router.navigateByUrl('/manage/dashboard')
    }
    this.rewardPermissions = this.rewardPermissions[0]['permission'];
    this.staticPath = environment.uploadUrl;
    this.pagetitle = 'Edit Rewards';
    this.id = this.activatedRoute.snapshot.paramMap.get("id");
    this.rid = this.activatedRoute.snapshot.params.id;
    this.getRewardDetails(this.rid);
    this.isAddMode = !this.id;
    this.rewardForm = this.formBuilder.group({
      reward_name: ['', [Validators.required]],
      coins: ['', [Validators.required, Validators.pattern('^[0-9]+$')]],
      size: ['', Validators.required],
      description: ['', [Validators.required]],
      reward_images: this.formBuilder.array([]),
      status: ['', Validators.required],
      disable: [false],
    });
  }

  getRewardDetails(id) {
    this.rewardsService.getRewardDetails(id).pipe(takeUntil(this.destroy$)).subscribe(data => {
      this.rewardData = data;
      if (this.rewardData) {
        this.update_rewardImageLink_info = [...(this.rewardData['reward_images'] || [])];
        this.rewardForm.patchValue({
            reward_name: this.rewardData['reward_name'],
            coins: this.rewardData['coins'],
            description: this.rewardData['description'],
        });
        this.rewardForm.get('size').setValue(this.rewardData['size']);
        this.rewardForm.get('status').setValue(this.rewardData['status']);
      }
    },
    err => {
      this.errorMessage = err.error.message;
    });
  }

  get rewardImagesFormArray(): FormArray {
    return this.rewardForm.get('reward_images') as FormArray;
  }

  onFileSelect(event: any) {
      const files: File[] = Array.from(event.files || []);
      if (files.length === 0) {
        return;
      }
      const validFiles: File[] = [];
      files.forEach((file: File) => {
        if (file.size > this.imageSize) {
          this.messageService.add({
            key: 'toastmsg',
            severity: 'error',
            summary: 'Image Too Large',
            detail: `${file.name} exceeds 1 MB`,
            life: 4000
          });
        } else {
          validFiles.push(file);
        }
      });
      this.clearFileInput();
      if (validFiles.length === 0) {
        return;
      }

      this.batchStartImageCount = this.rewardImagesFormArray.length;
      this.batchCropCompleted = false;
      this.isApplyingCrop = false;
      this.imageQueue = [...validFiles];
      this.currentImageIndex = 0;
      this.loadCropperImage();
    }
  
    loadCropperImage() {
      const file = this.imageQueue[this.currentImageIndex];
      if (!file) {
        this.cropDialog = false;
        return;
      }
      this.croppedImage = null;
      this.resetCropValidation();
      this.resetZoom();
      this.isApplyingCrop = false;
      this.imageChangedEvent = {
        target: {
          files: [file]
        }
      };
      this.cropDialog = true;
    }

    get cropDialogTitle(): string {
      return 'Crop & Adjust Reward Photo';
    }

    get cropDialogSubtitle(): string {
      const progress = this.imageQueue.length
        ? `Photo ${this.currentImageIndex + 1} of ${this.imageQueue.length} - `
        : '';
      return `${progress}position and scale your image for a 1000 x 1000 crop`;
    }

    get cropPreviewLabel(): string {
      return '1000 x 1000 px - High Quality JPEG';
    }

    zoomIn() {
      this.scale = Math.min(3, Number((this.scale + 0.1).toFixed(1)));
      this.transform = {
        ...this.transform,
        scale: this.scale
      };
    }

    zoomOut() {
      this.scale = Math.max(1, Number((this.scale - 0.1).toFixed(1)));
      this.transform = {
        ...this.transform,
        scale: this.scale
      };
    }

    resetZoom() {
      this.scale = 1;
      this.transform = {
        ...this.transform,
        scale: 1
      };
    }
  
    imageCropped(event: ImageCroppedEvent) {
      this.croppedImage = event.base64;
      this.croppedImageSize = this.getBase64SizeBytes(this.croppedImage);
      this.croppedImageError = this.croppedImageSize > this.croppedImageMaxSize
        ? 'Cropped image size must not exceed 1 MB.'
        : null;
    }

    onCropImageLoadFailed() {
      this.croppedImage = null;
      this.croppedImageSize = 0;
      this.croppedImageError = 'This image could not be loaded. Please choose a valid image file.';
    }
  
    getBase64SizeBytes(base64: string): number {
      if (!base64) return 0;
      return Math.round(
        (base64.length * (3 / 4)) -
        (base64.split(',')[0].length + 1)
      );
    }
  
    applyCrop() {
      if (this.isApplyingCrop || this.croppedImageError || !this.croppedImage) return;
      const currentFile = this.imageQueue[this.currentImageIndex];
      if (!currentFile) {
        this.croppedImageError = 'The selected photo is no longer available. Cancel and choose it again.';
        return;
      }

      this.isApplyingCrop = true;
      const croppedFile = this.base64ToFile(
        this.croppedImage,
        this.getOutputFileName(currentFile.name)
      );
      if (croppedFile.size > this.croppedImageMaxSize) {
        this.croppedImageError = 'Cropped image size must not exceed 1 MB.';
        this.isApplyingCrop = false;
        return;
      }

      const rewardImage = this.formBuilder.group({
        file: this.croppedImage
      });
      this.rewardImagesFormArray.push(rewardImage);
      this.currentImageIndex++;
      if (this.currentImageIndex < this.imageQueue.length) {
        this.loadCropperImage();
      } else {
        this.finishUploadFlow();
      }
    }
  
    finishUploadFlow() {
      this.batchCropCompleted = true;
      this.cropDialog = false;
    }
  
    onCropCancel() {
      this.batchCropCompleted = false;
      this.cropDialog = false;
    }

    onDialogHide() {
      if (!this.batchCropCompleted) {
        this.rollbackCurrentBatch();
      }
      this.resetCropFlow();
    }

    private rollbackCurrentBatch() {
      while (this.rewardImagesFormArray.length > this.batchStartImageCount) {
        this.rewardImagesFormArray.removeAt(this.rewardImagesFormArray.length - 1);
      }
    }

    private resetCropFlow() {
      this.imageQueue = [];
      this.currentImageIndex = 0;
      this.imageChangedEvent = null;
      this.croppedImage = null;
      this.resetCropValidation();
      this.resetZoom();
      this.batchStartImageCount = this.rewardImagesFormArray.length;
      this.batchCropCompleted = false;
      this.isApplyingCrop = false;
      this.clearFileInput();
    }

    private clearFileInput() {
      if (this.fileUpload) {
        this.fileUpload.clear();
      }
      const input = this.fileUploadEl?.nativeElement?.querySelector('input[type="file"]') as HTMLInputElement;
      if (input) {
        input.value = '';
      }
    }

    resetCropValidation() {
      this.croppedImageError = null;
      this.croppedImageSize = 0;
    }
  
    removeRewardImages(index: number) {
      this.rewardImagesFormArray.removeAt(index);
    }
  
    base64ToFile(data: string, filename: string): File {
      const arr = data.split(',');
      const mime = arr[0].match(/:(.*?);/)[1];
      const bstr = atob(arr[1]);
      let n = bstr.length;
      const u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, { type: mime });
    }

    private getOutputFileName(filename: string | undefined): string {
      const baseName = (filename || 'reward-photo').replace(/\.[^/.]+$/, '');
      return `${baseName}.jpg`;
    }

  uploadRewardImages(event) {
    for (let file of event.files) {
      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        if (reader.result != null) {
          if (!this.sampleRewordImagesLinkArray.includes(file.name)) {
            this.sampleRewordImagesLinkArray.push(file.name);
            const rewardImage = this.formBuilder.group({
              file: reader.result
            })
            this.rewardImagesFormArray.push(rewardImage);
          }
        }
      }
    }
  }

  // removeRewardImages(event) {
  //   const rewardImageindex = this.sampleRewordImagesLinkArray.findIndex(ele => ele === event.file.name);
  //   this.sampleRewordImagesLinkArray.splice(rewardImageindex,1);
  //   this.rewardImagesFormArray.removeAt(rewardImageindex);
  // }

  removeRewardPhotos(rewardImages, i) {
    this.confirmationService.confirm({
      message: `
        <h4 style="margin:0;">Are you sure?</h4>
        <p style="margin-top:10px;">
          You want to delete this image ?
        </p>
      `,
      acceptLabel: 'Confirm',
      rejectLabel: 'Cancel',
      header: 'Confirm',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        const removedImage = rewardImages[i];
        this.deleted_images.push(removedImage.reward_image_src);
        rewardImages.splice(i,1);
        const retainedImageIndex = this.update_rewardImageLink_info.findIndex(image => image === removedImage);
        if (retainedImageIndex >= 0) {
          this.update_rewardImageLink_info.splice(retainedImageIndex, 1);
        }
        if (this.update_rewardImageLink_info.length === 0) {
          this.showRewardImageError = true;
        }
      },
      reject: () => {}
    });
  }

  get f() {
    return this.rewardForm.controls;
  }

  onSubmit() {
    this.submitted = true;
    if (this.rewardForm.invalid) {
      return;
    }
    if (this.rewardImagesFormArray.length === 0 && this.update_rewardImageLink_info.length === 0) {
      return;
    }
    var rewardData = JSON.parse(JSON.stringify(this.rewardForm.value));
    if (this.deleted_images.length > 0) {
      rewardData['deleted_images'] = this.deleted_images;
    }
    rewardData['update_rewardImageLink_info']=this.update_rewardImageLink_info;
    rewardData = JSON.stringify(rewardData, null, 4);
    this.rewardsService.updateReward(this.rid,rewardData).pipe(takeUntil(this.destroy$)).subscribe(data => {
        this.messageService.add({ key: 'toastmsg', severity: 'success', summary: 'Successful', detail: 'Rewards Added Successfully!!', life: 6000 });
        setTimeout(() => {
          this.router.navigate(['/manage/rewards']);
        }, 2000);
      },
      ((err) => {
        this.messageService.add({ key: 'toastmsg', severity: 'error', summary: "Error", detail: err.error.message, life: 6000 });
      })
    );
  }

  backLink() {
    this.router.navigate(['/manage/rewards']);
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
